// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"styles_Sidebar__ezLoX","Sidebar__title":"styles_Sidebar__title__aDKzx"};